import React from 'react';
import { Tooltip, Popover, PopoverTrigger, PopoverContent } from '@heroui/react';
import { useIsMobile } from '../../hooks/useMobile';

type ResponsiveTooltipProps = React.ComponentProps<typeof Tooltip> & {
  popoverPlacement?: React.ComponentProps<typeof Popover>['placement'];
};

export function ResponsiveTooltip({
  children,
  popoverPlacement,
  placement,
  content,
  classNames,
  ...props
}: ResponsiveTooltipProps) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Popover placement={popoverPlacement ?? placement} offset={8}>
        <PopoverTrigger>{children as React.ReactElement}</PopoverTrigger>
        <PopoverContent className={classNames?.content}>{content}</PopoverContent>
      </Popover>
    );
  }

  return (
    <Tooltip content={content} placement={placement} classNames={classNames} {...props}>
      {children}
    </Tooltip>
  );
}
